import styled from "styled-components";
import { px2rem } from "utils/browser/resizer";

export const DiscountInfoBox = styled.section`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	z-index: 1;
	pointer-events: none;

	.descImg {
		display: block;
		position: absolute;
		top: 0;
		left: 0;
		max-width: 40%;
		max-height: 9.6%;
		height: auto;
		object-fit: initial !important;
	}

	.discountIcon {
		position: absolute;
		top: 0;
		right: 0;
		max-height: 13%;
		max-width: 40%;
		height: auto;
	}
	.themeTag {
		display: block;
		position: absolute;
		bottom: 0;
		left: 0;
		max-width: 80%;
		max-height: 9.6%;
		height: fit-content;
		width: auto;
		object-fit: initial !important;
	}
`;

export const LeftTopTags = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	height: 20px;
	z-index: 2;
	border-top-left-radius: 0.25rem;
	border-bottom-right-radius: ${px2rem(10)};
	> img {
		width: auto;
		height: 20px;
		object-fit: cover;
		&:first-child {
			border-top-left-radius: ${px2rem(4)};
		}
		&:last-child {
			border-bottom-right-radius: ${px2rem(10)};
		}
	}
`;

export const RightTopTag = styled.img`
	position: absolute;
	top: 0;
	right: 0;
	border-radius: 0px 4px 0px 0;
	transform: scale(0.333);
	transform-origin: top right;
	max-height: 100%;
`;
